import React, { useState } from 'react';
import UserGroups from './userGroups';
import GroupDetails from './groupDetails';
import UserDetails from './userDetails';

import { put, post, get } from '../../utils/apiUtils';

const GroupUserNavComponent = () => {
  const [activePage, setActivePage] = useState('groupListing');
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  const handleSelectGroup = (group) => {
    setSelectedGroup(group);
    setActivePage('groupDetails');
  };

  const handleSelectUser = (user) => {
    setSelectedUser(user);
    setActivePage('userDetails');
  };

  const handleSaveGroup = async (groupDetails) => {
    if (groupDetails && groupDetails.id) {
      try {
        const updateResponse = await put(`/api/v1/persistence/user_group`, groupDetails, {
          withCredentials: true,
        });
        setSelectedGroup(updateResponse);
      } catch (error) {
        console.error('Error updating group:', error);
      }
    } else {
      try {
        const createResponse = await post(`/api/v1/persistence/user_group`, groupDetails, {
          withCredentials: true,
        });
        setSelectedGroup(createResponse);
      } catch (error) {
        console.error('Error updating group:', error);
      }
    }

  };
  const handleSaveUser = async (userDetails) => {
    console.log('Save User:', userDetails);
    if (userDetails && userDetails.id) {
      try {
        const updateResponse = await put(`/api/v1/persistence/users`, userDetails, {
          withCredentials: true,
        });
        setSelectedUser(updateResponse);
        setActivePage('groupDetails');
      } catch (error) {
        console.error('Error updating group:', error);
      }
    } else {
      try {
        userDetails.username = userDetails.email;
        const createResponse = await post(`/api/v1/persistence/users`, userDetails, {
          withCredentials: true,
        });
        setSelectedUser(createResponse);
        try {
          let payload = {
            group: selectedGroup.name,
            entity_id: createResponse.username,
            company_cd: createResponse.company_cd,
            entity_type: 'user'
          }
          const linkageResponse = await post(`/api/v1/persistence/user_group_mapping`, payload, {
            withCredentials: true,
          });
          setActivePage('groupDetails');

        } catch (error) {
          console.error('Error updating group Linkage:', error);
        }
      } catch (error) {
        console.error('Error updating group:', error);
      }
    }
  };

  return (
    <div>
      {activePage === 'groupListing' && <UserGroups onSelectGroup={handleSelectGroup} />}
      {activePage === 'groupDetails' && (
        <GroupDetails
          group={selectedGroup}
          onSelectUser={handleSelectUser}
          onSaveGroup={handleSaveGroup}
        />
      )}
      {activePage === 'userDetails' && (
        <UserDetails user={selectedUser} onSaveUser={handleSaveUser} />
      )}
    </div>
  );
};

export default GroupUserNavComponent;